<template>
<div class="list">
  <h1>列表</h1>
  <p v-for="(system,index) in list" :key="system.id" class="123">
      <span>{{system}}</span>
    <span @click="deleteSystem(index)">删除</span>
  </p>
</div>


</template>

<script>
export default {
  data(){
    return{
      list:[],
      info:{}
    }
  },
  created(){
    this.loadSystemList()
  },
  methods:{
    loadSystemList() {
      let url = "categories",
        params = {
          auth_token: "default"
        };
      this.$http.get(url, { params }).then(data => {
        if (data.status_code === "SUCCEEDED") {
          this.list=data.payload
          console.log(data);
        } else {
          console.error(data);
        }
      });
    },
    deleteSystem(index){
      let url = `categories/${this.list[index].id}/destroy`,
          params={
            auth_token:'default'
          }
          this.$http.delete(url,{params}).then(
            data=>{
              console.info(data)
            }
          )
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/view/subSystem/systemList.vue